export const onStyleOverriden = () => () => {
    console.log('style overridden');
};
